import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideNgxMask } from 'ngx-mask';
import {
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ModalModule } from 'ngx-bootstrap/modal';
import {
  RECAPTCHA_LOADER_OPTIONS,
  RECAPTCHA_V3_SITE_KEY,
  RecaptchaV3Module,
} from 'ng-recaptcha';
import { environment } from '../environments/environment';
import localePl from '@angular/common/locales/pl';
import { registerLocaleData } from '@angular/common';
import { Angulartics2Module } from 'angulartics2';
import {
  provideClientHydration,
  withEventReplay,
  withHttpTransferCacheOptions,
  withIncrementalHydration,
} from '@angular/platform-browser';
import {
  NgcCookieConsentConfig,
  provideNgcCookieConsent,
} from 'ngx-cookieconsent';

registerLocaleData(localePl);

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: environment.domain,
  },
  position: 'bottom',
  theme: 'classic',
  palette: {
    popup: {
      background: '#e83066',
      text: '#ffffff',
      link: '#ffffff',
    },
    button: {
      background: '#182e95',
      text: '#fff',
      border: 'transparent',
    },
  },
  type: 'opt-in',
  content: {
    message:
      'Ta strona używa plików cookie, aby zapewnić Ci najlepsze doświadczenia na naszej stronie.',
    deny: 'Odrzuć pliki cookie',
    allow: 'Zezwól na pliki cookie',
    // link: 'Dowiedz się więcej',
    link: '',
    // href: 'https://cookiesandyou.com',
    href: '',
    policy: 'Polityka plików cookie',
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideNgcCookieConsent(cookieConfig),
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        // anchorScrolling: 'enabled',
        // onSameUrlNavigation: 'reload',
        // scrollPositionRestoration: 'enabled',
      }),
    ),
    provideClientHydration(
      withHttpTransferCacheOptions({
        includePostRequests: true, // to include POST
      }),
      withEventReplay(),
      withIncrementalHydration(),
    ),
    provideAnimations(),
    provideToastr({
      timeOut: 10000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    provideNgxMask(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    importProvidersFrom(ModalModule.forRoot()),
    importProvidersFrom(RecaptchaV3Module),
    importProvidersFrom(Angulartics2Module.forRoot()),
    { provide: LOCALE_ID, useValue: 'pl-PL' },
    {
      provide: RECAPTCHA_LOADER_OPTIONS,
      useFactory: (locale: string) => ({
        onBeforeLoad(url: URL) {
          url.searchParams.set('hl', locale);
          return { url };
        },
      }),
      deps: [LOCALE_ID],
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptchaV3SiteKey,
    },
  ],
};
